@if (filters$ | async; as filters) {
  <div class="results__filters-menu" [ngStyle]="{ position:'fixed' }">
    @if (filters) {
      <button mb-button variant="floating" color="secondary"
        [loading]="!filters?.list?.length || (loading$ | async)" [disabled]="!filters?.list?.length || (loading$ | async)"
        (click)="toggleShowFilters()">
          <mb-icon icon="filter-equalizer"></mb-icon>
          <span>Filtrar</span>
          <span id="total-filter">
            @if (filters.applied?.length) {
              ({{filters.applied?.length}})
            }
          </span>
      </button>
    }
    @if (!map) {
      <span class="divider"></span>
      <am-sorting-by-mobile [loading]="loading$ | async"
        [disabled]="(loading$ | async) || !(hotels$ | async)?.length"></am-sorting-by-mobile>
    }
    @if (!(context$ | async)?.isLanding) {
      <span class="divider"></span>
      <am-view-map [isMap]="map" [isMobile]="true"></am-view-map>
    }
  </div>
}